import React from "react";
import styled from "styled-components";

const TabsComponent = ({ tabs, activeTab, onTabChange, children }) => {
  return (
    <Container>
      <TabsList>
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            active={activeTab === index}
            onClick={() => onTabChange(index)}
          >
            {tab}
          </Tab>
        ))}
      </TabsList>
      <TabContent>
        {children}
      </TabContent>
    </Container>
  );
};

// Styled Components
const Container = styled.div`
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const TabsList = styled.div`
  display: flex;
  background: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;
`;

const Tab = styled.button`
  flex: 1;
  padding: 16px 24px;
  background: ${props => props.active ? 'white' : 'transparent'};
  border: none;
  border-bottom: ${props => props.active ? '2px solid #3b82f6' : '2px solid transparent'};
  color: ${props => props.active ? '#3b82f6' : '#6b7280'};
  font-family: "Poppins";
  font-weight: ${props => props.active ? '600' : '500'};
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    color: #3b82f6;
    background: ${props => props.active ? 'white' : '#f3f4f6'};
  }

  &:focus {
    outline: none;
  }
`;

const TabContent = styled.div`
  min-height: 400px;
`;

export default TabsComponent;